<template>
  <section>
    <!--工具条-->
    <el-card style="">
      <div style="display: flex; width: 100%; margin-top: 20px">
        <div class="">
          <el-select v-model="value1" placeholder="请选择学届" @change="onOptionsyear" id="inputselect">
            <el-option v-for="item in optionsyear" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <!-- 2 -->
        <div class="">
          <el-select v-model="value2" placeholder="请选择年级" @change="onOptionsyear2" id="inputselect">
            <el-option v-for="item in optionsyear2" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <div class="">
          <el-select v-model="value2" placeholder="请选择班级" @change="onOptionsyear3" id="inputselect">
            <el-option v-for="item in optionsyear3" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </div>
      </div>
    </el-card>
    <el-card style="margin: 20px 0">
      <div style="padding-left: 10px">
        <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
      </div>
    </el-card>
    <el-table :data="users" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      " :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }" empty-text="暂无数据" :row-style="{ height: '50px' }" :cell-style="{ padding: '15px 0 15px 0px' }">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label=" " width align="center">
        <template scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column prop="StudyYearName" label="学届" width sortable align="center"></el-table-column>
      <el-table-column prop="GradeName" label="年级" width sortable></el-table-column>
      <el-table-column prop="ClassName" label="班级" width sortable align="center"></el-table-column>
      <el-table-column prop="Name" label="学生姓名" width sortable align="center"></el-table-column>
      <el-table-column prop="StudentCode" label="学号" width sortable align="center"></el-table-column>
      <el-table-column prop="SexName" label="性别" width sortable align="center"></el-table-column>
      <el-table-column label="操作" width sortable align="center">
        <template slot-scope="scope">
          <span class="SpanList" @click="setResetPawassed(scope.row)">重置密码</span>
          <span class="SpanList" @click="handleEdit(scope.row)">编辑</span>
          <!-- <span class="SpanList" @click="handleDel(scope.row.Id)">删除</span> -->
        </template>
        <!-- <el-button type="primary" @click="setResetPawassed(scope.row)"
            >重置密码</el-button
          > -->
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-button type="danger" @click="batchRemove" style="margin: 20px 0 0 20px" :disabled="this.sels.length === 0">
        批量删除</el-button>
      <el-pagination layout="sizes, prev, pager, next" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-sizes="[5, 10, 20, 30, 40]" :page-size="PageSize" :total="total"
        style="text-align: center; margin-top: 100px" background></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
      custom-class="subTitle" :show-close="false">
      <span slot="title">
        <h2>
          新增
          <span @click="DialogDown()" style="float: right; width: 100px; font-size: 20px; cursor: pointer">x</span>
        </h2>
      </span>
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-form-item label="学生名称" prop="name">
          <el-input v-model="editForm.Name"></el-input>
        </el-form-item>
        <el-form-item label="学号" prop="studentCode">
          <el-input v-model="editForm.StudentCode"></el-input>
        </el-form-item>
        <!-- <el-form-item label="密码" prop="password">
          <el-input v-model="editForm.password"></el-input>
        </el-form-item> -->
        <el-form-item label="所属学届" prop="value1">
          <el-select v-model="editForm.StudyYearName" placeholder="请选择所属学届">
            <el-option v-for="item in AddOptionsyear" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属年级" prop="value2">
          <el-select v-model="editForm.GradeName" placeholder="请选择所属年级" @change="editUserScroll">
            <el-option v-for="item in AddOptionsyear2" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属班级" prop="value3">
          <el-select v-model="editForm.ClassName" placeholder="请选择所属班级">
            <el-option v-for="item in AddOptionsyear3" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="editForm.Sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">保存</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
      custom-class="subTitle" :show-close="false">
      <span slot="title">
        <h2>
          新增
          <span @click="DialogDown()" style="float: right; width: 100px; font-size: 20px; cursor: pointer">x</span>
        </h2>
      </span>
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-form-item label="学生名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="学号" prop="studentCode">
          <el-input v-model="addForm.studentCode"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password" show-password type="password"></el-input>
        </el-form-item>
        <el-form-item label="所属学届" prop="value1">
          <el-select v-model="addForm.value1" placeholder="请选择所属学届">
            <el-option v-for="item in AddOptionsyear" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属年级" prop="value2">
          <el-select v-model="addForm.value2" placeholder="请选择所属年级" @change="getUserScroll">
            <el-option v-for="item in AddOptionsyear2" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属班级" prop="value3">
          <el-select v-model="addForm.value3" placeholder="请选择所属班级">
            <el-option v-for="item in AddOptionsyear3" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="addForm.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
    <!-- 重置密码 -->
    <el-dialog title="操作" :visible.sync="passwordDialogVisible" width="30%" custom-class="subTitle" :show-close="false">
      <span slot="title">
        <h2>
          重置密码
          <span @click="DialogDown()" style="float: right; width: 100px; font-size: 20px; cursor: pointer">x</span>
        </h2>
      </span>
      <div>
        <el-input v-model="isPawassrd" type="password" @blur="isBlur" show-password placeholder="请输入密码"></el-input>
        <div style="color:red" v-if="isTrue">请输入大写字母、小写字母、数字和特殊符号，这4类必须包括3类，长度8到16位</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="btnPassword">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 上传 -->
    <el-dialog title="提示" :visible.sync="dialogVisibleData" width="30%" custom-class="subTitle" :show-close="false">
      <span slot="title">
        <h2>
          导入学生
          <span @click="DialogDown()" style="float: right; width: 100px; font-size: 20px; cursor: pointer">x</span>
        </h2>
      </span>
      <el-upload class="image-uploader" :multiple="false" :auto-upload="true" :show-file-list="true"
        :before-upload="beforeUpload" :drag="true" action="" :limit="1" :on-exceed="handleExceed"
        :http-request="uploadFile">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleData = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleData = false">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import store from "../../store";
import util from "../../../util/date";
import {
  GetCateListByPage,
  GetStudentInfoByPage,
  GetYearsInfo,
  GetGradeInfo,
  GetClassInfo,
  AddStudent,
  RestPassword,
  DeleteStudent,
  UpdateStudent,
  QuestionInfoDelete,
  HotQuestionInfoUpdate,
  HotQuestionInfoAdd,
  ImportUploadFileExcel,
  ImportExcelSaveFile,
  BatchDeleteStudent,
  AddRecordInfo,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { isString } from "../../../util/validate";

export default {
  components: { Toolbar, quillEditor },
  data() {
    var validatePass = (rule, value, callback) => {
      var regex = new RegExp('^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$')
      const isTrue = regex.test(value);
      if (!isTrue) {
        callback(new Error('请输入密码长度8-16位，至少包含大小写字母，数字，特殊符号中的三种'));
      }
      callback()
    };
    return {
      passwordDialogVisible: false,
      dialogVisibleData: false,
      value1: "",
      value2: "",
      value3: "",
      isPawassrd: "",
      studentNum: "",
      studentName: "",
      optionsyear: [],
      optionsyear2: [],
      optionsyear3: [],
      AddOptionsyear: [],
      AddOptionsyear2: [],
      AddOptionsyear3: [],
      headers: {
        Authorization: "",
      },
      contentstatus: false,
      content: ``,
      editorOption: {},
      imageUrl: "",
      catelist: [],
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      users: [],
      //statusList: [{LinkUrl: '激活', value: true}, {LinkUrl: '禁用', value: false}],
      total: 0,
      page: 1,
      PageSize: 10,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        CateId: [{ required: true, message: "请选择分类", trigger: "blur" }],
        QuestionTitle: [
          { required: true, message: "请输入问题", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        Name: "",
        StudentCode: "",
        StudyYearName: "",
        GradeName: "",
        ClassName: "",
        Sex: 1,
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入学生名称", trigger: "blur" }],
        password: [{ validator: validatePass, trigger: 'blur' }],
        studentCode: [
          { required: true, message: "请输入所属学号", trigger: "blur" },
        ],
        value1: [
          { required: true, message: "请输入所属学届", trigger: "blur" },
        ],
        value2: [
          { required: true, message: "请输入所属年级", trigger: "blur" },
        ],
        value3: [
          { required: true, message: "请输入所属班级", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        name: "",
        studentCode: "",
        value1: "",
        value2: "",
        value3: "",
        sex: "1",
        password: "",
      },
      passwordRow: 0,
      isTrue: false
    };
  },
  modules: {
    toolbar: {
      container: [
        //配置项，全部配置如上
        ["bold", "italic", "underline"],
        [{ align: [] }],
        ["image"],
      ],
      handlers: {
        image: function (value) {
          if (value) {
            document.querySelector(".avatar-uploader input").click();
          } else {
            this.quill.format("image", false);
          }
        },
      },
    },
  },
  created() {
    this.GetYearsInfo();
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  methods: {
    isBlur() {
      this.isTrue = false
    },
    async AddRecordInfo(action, description) {
      var user = JSON.parse(
        window.localStorage.user ? window.localStorage.user : null
      );
      let res = await AddRecordInfo({
        userName: user.uRealName + "-" + user.uLoginName,
        action: action,
        description: description,
      });
    },
    onClickTemplate() {
      window.open(
        "https://qinghesuyang.admin.yrtsedu.cn/content/商业会计学校学生导入模板.xlsx",
        "_blank"
      );
    },
    DialogDown() {
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.passwordDialogVisible = false;
      this.dialogVisibleData = false;
    },
    // 上传文件个数超过定义的数量
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    // 上传文件之前的钩子
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(testmsg);
      const extension = testmsg === "xlsx";
      const extension2 = testmsg === "xls";
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是xlsx或xls格式！",
          type: "error",
        });
      }

      return extension;
    },
    // 上传文件
    uploadFile(item) {
      console.log(item);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("comId", this.comId);

      console.log(form);
      ImportUploadFileExcel(form).then((response) => {
        console.log("MediaAPI.upload");
        console.log(response);
        this.addForm.ContentUrl = response.data.url;
        console.log("filename", this.addForm.ContentUrl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
        if (response.data.success) {
          ImportExcelSaveFile({ sFileName: response.data.url }).then((res) => {
            if (res.data.success) {
              this.dialogVisibleData = false;
            }
          });
        }
      });
    },
    Import() {
      this.dialogVisibleData = true;
    },
    // 重置密码
    setResetPawassed(row) {
      this.passwordRow = row.Id;
      console.log(row.Id);
      this.passwordDialogVisible = true;
    },
    btnPassword() {
      // var regex = new RegExp('(?=.*[0-9])(?=.*[A-Za-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{8,16}$')
      var regex = new RegExp('^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$')
      const isTrue = regex.test(this.isPawassrd);

      if (isTrue) {
        this.isTrue = false
        let params = {
          id: this.passwordRow,
          password: this.isPawassrd,
        };
        RestPassword(params).then((res) => {
          if (res.data.success) {
            this.AddRecordInfo(
              "修改",
              "基础信息管理-学生信息管理-重置密码-重置学生密码"
            );
            this.$message({
              message: "重置成功",
              type: "success",
            });
            this.passwordDialogVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.isTrue = true
        // this.$message({
        //   message: "请输入大写字母、小写字母、数字和特殊符号，这4类必须包括3类，长度8到16位",
        //   type: "error",
        // });
      }
    },
    onOptionsyear() {
      this.page = 1;
      GetGradeInfo().then((res) => {
        // if (res.data.response.length > 0) {
        //   this.value2 = res.data.response[0].Id;
        //   //   this.onOptionsyear();
        // }
        this.optionsyear2 = res.data.response;
        this.getModules();
      });
    },
    onOptionsyear2() {
      this.page = 1;
      if (this.value1 != "" && this.value2 != "") {
        GetClassInfo({
          studyYearId: this.value1,
          gradeId: this.value2,
        }).then((res) => {
          this.optionsyear3 = res.data.response;
          this.getModules();
        });
      }
    },
    onOptionsyear3() {
      this.page = 1;
      this.getModules();
    },
    //获取班级列表
    GetYearsInfo() {
      GetYearsInfo().then((res) => {
        this.optionsyear = res.data.response;
      });

      //   this.onOptionsyear();
    },
    radiochange(val) {
      console.log(val);
      // if (val == 1) {
      //   this.contentstatus=false;
      // } else {
      //     this.contentstatus=true;
      // }
    },
    onEditorReady(editor) { }, // 准备编辑器
    onEditorBlur() { }, // 失去焦点事件
    onEditorFocus() { }, // 获得焦点事件
    onEditorChange() { }, // 内容改变事件
    saveHtml(event) {
      alert(this.content);
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.response;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      console.log(item);
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.CreateTime),
          "yyyy-MM-dd hh:MM:ss"
        );
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.getModules();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.page = val;
      this.getModules();
    },
    // changeStatus(val){
    //     this.statusvalue=val;
    //     this.getModules();
    // },
    //获取分类
    getCateInfo() {
      let para = {};
      GetCateListByPage(para).then((res) => {
        this.catelist = res.data.response;
      });
    },
    //获取用户列表
    getModules() {
      let para = {
        StudyYearId: this.value1 == "" ? 0 : this.value1,
        GradeId: this.value2 == "" ? 0 : this.value2,
        ClassId: this.value3 == "" ? 0 : this.value3,
        Name: this.filters.name,
        PageIndex: this.page,
        PageSize: this.PageSize,
      };
      this.listLoading = true;

      //NProgress.start();
      GetStudentInfoByPage(para).then((res) => {
        this.AddRecordInfo(
          "查询",
          "基础信息管理-学生信息管理-查看学生信息列表"
        );

        this.listLoading = false;
        this.users = res.data.response.data;
        this.total = res.data.response.dataCount;
        //NProgress.done();
      });
    },
    // 批量删除
    onClickDelete() { },
    //删除
    handleDel(id) {
      // let row = this.currentRow;
      // if (!row) {
      //   this.$message({
      //     message: "请选择要删除的一行数据！",
      //     type: "error",
      //   });

      //   return;
      // }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { Id: id };
          DeleteStudent(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit(row) {
      // let row = this.currentRow;

      // if (!row) {
      //   this.$message({
      //     message: "请选择要编辑的一行数据！",
      //     type: "error",
      //   });

      //   return;
      // }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      GetYearsInfo().then((res) => {
        this.AddOptionsyear = res.data.response;
        GetGradeInfo().then((res) => {
          this.AddOptionsyear2 = res.data.response;
        });
      });
      console.log(this.editForm);
      // this.imageUrl = this.editForm.QuestionImg;
      // if (this.editForm.QuestionType == 1) {
      //   this.contentstatus=false;
      // } else {
      //     this.contentstatus=true;
      // }
    },
    // //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      GetYearsInfo().then((res) => {
        this.AddOptionsyear = res.data.response;
        GetGradeInfo().then((res) => {
          this.AddOptionsyear2 = res.data.response;
        });
      });
    },
    // 年级下拉事件
    getUserScroll() {
      if (this.addForm.value1 != "" && this.addForm.value2 != "") {
        GetClassInfo({
          studyYearId: this.addForm.value1,
          gradeId: this.addForm.value2,
        }).then((res) => {
          this.AddOptionsyear3 = res.data.response;
        });
      }
    },
    editUserScroll() {
      if (this.editForm.StudyYearName != "" && this.editForm.GradeName != "") {
        console.log(this.editForm.StudyYearId);
        GetClassInfo({
          studyYearId: this.isString(this.editForm.StudyYearName)
            ? this.editForm.StudyYearId
            : this.editForm.StudyYearName,
          gradeId: this.isString(this.editForm.GradeName)
            ? this.editForm.GradeId
            : this.editForm.GradeName,
        }).then((res) => {
          this.AddOptionsyear3 = res.data.response;
        });
      }
    },
    isString(str) {
      return str instanceof String || typeof str == "string";
    },
    //编辑
    editSubmit: function () {
      this.headers.Authorization = "Bearer " + store.state.token;
      this.$confirm("确定编辑该内容?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = Object.assign({}, this.editForm);
          console.log(para, "测试");
          let params = {
            Id: this.editForm.Id,
            studyYearId: this.isString(para.StudyYearName)
              ? this.editForm.StudyYearId
              : para.StudyYearName,
            gradeId: this.isString(para.GradeName)
              ? this.editForm.GradeId
              : para.GradeName,
            classId: this.isString(para.ClassName)
              ? this.editForm.ClassId
              : para.ClassName,
            name: para.Name,
            code: para.StudentCode,
            sex: para.Sex,
          };
          console.log(params);
          UpdateStudent(params).then((res) => {
            console.log(res, "-");
            if (res.data.success) {
              this.AddRecordInfo(
                "修改",
                "基础信息管理-学生信息管理-编辑-编辑学生信息"
              );
              this.$message({
                message: "编辑成功",
                type: "success",
              });
              this.editFormVisible = false;
              this.getModules();
              console.log(this.editFormVisible);
            }
          });
        })
        .catch(() => { });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      console.log(this.$refs.addForm)
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let params = {
              studyYearId: _this.addForm.value1,
              gradeId: _this.addForm.value2,
              classId: _this.addForm.value3,
              name: _this.addForm.name,
              code: _this.addForm.studentCode,
              sex: _this.addForm.sex,
              password: _this.addForm.password,
            };
            AddStudent(params).then((res) => {
              if (res.data.success) {
                this.AddRecordInfo(
                  "新增",
                  "基础信息管理-学生信息管理-导入学生"
                );
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.addFormVisible = false;
                this.getModules();
              }
            });
          });
        }
      });
    },
    //批量删除
    batchRemove: function () {
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { ids: this.sels };

          BatchDeleteStudent(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            console.log(res);
            this.getModules();
          });
        })
        .catch(() => { });
    },
    selsChange: function (sels) {
      console.log(sels);
      let ids = [];
      sels.map((item) => {
        ids.push(item.Id);
      });
      console.log(ids);
      this.sels = ids;
    },
  },
  mounted() {
    this.getModules();
    // this.getCateInfo();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.headers.Authorization = "Bearer " + store.state.token;
  },
};
</script>

<style scoped>
.demo-input-suffix {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  margin-left: 20px;
}

.btnQuery {
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-input {
  width: 150px;
  margin: 10px;
}

.el-select {
  margin: 10px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 320px;
  height: 180px;
  line-height: 180px;
  text-align: center;
}

.avatar {
  width: 320px;
  height: 180px;
  display: block;
}
</style>
